import React from 'react';
import { CalculatorIcon, ClipboardListIcon, NetworkIcon, SearchCheckIcon, TargetIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  clipboard: ClipboardListIcon,
  network: NetworkIcon,
  search: SearchCheckIcon,
  calculator: CalculatorIcon,
  target: TargetIcon
};
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-b border-line bg-canvasAlt" data-id="element-27" data-mp="14sj2k0g4ikvk">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-5" data-id="element-28" data-mp="ztgadgl8s950">
        <h2 id="bonos" className="font-display text-base font-extrabold uppercase leading-tight text-accent sm:text-xl" data-id="element-29" data-mp="1ej47s6qaynng">
          5 Bonos incluidos
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-ink-muted" data-id="element-30" data-mp="1njsppcith85m">
          Y además recibes 5 recursos prácticos — GRATIS con tu compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-31" data-mp="1jgdxzolin3cc">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-accent/40 bg-surface p-3 text-left" data-id="element-32" data-mp="3tsylddp3sjyu" data-mpi={i}>
                <span className="inline-flex w-fit items-center gap-1.5 rounded bg-accent px-2 py-0.5 font-display text-[0.6rem] font-black uppercase tracking-[0.12em] text-canvas" data-id="element-33" data-mp="7imb1bsw9db3">
                  <Icon size={11} data-id="element-34" data-mp="gjkglyizdsvs" />
                  Bono {i + 1} — Gratis
                </span>
                <h3 className="mt-1.5 font-display text-[0.82rem] font-extrabold uppercase leading-tight text-ink" data-id="element-35" data-mp="lcna66nrd2bz">
                  {bono.title}
                </h3>
                <p className="mt-1 text-[0.78rem] leading-snug text-ink-muted" data-id="element-36" data-mp="vb2vtu40nje3">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 font-display text-[0.72rem] font-black uppercase text-accent line-through decoration-danger decoration-2" data-id="element-37" data-mp="109wahpv1hgfu">
                  {bono.value}
                </p>
              </Reveal>;
        })}
        </ul>

        <p className="mt-3 inline-block rounded-lg border-2 border-accent bg-accent-soft px-3 py-2 font-display text-[0.78rem] font-black uppercase leading-tight text-accent sm:text-sm" data-id="element-38" data-mp="kbab3q98bft8">
          💰 Valor total de los 5 bonos: {BONUS_VALUE}
          <span className="mt-0.5 block text-cyan" data-id="element-39" data-mp="t9vsvj6vmqsy">
            🔥 Hoy los 5 están incluidos gratis.
          </span>
        </p>
      </div>
    </section>;
}